// @flow

import * as React from 'react';

type Props = {
  name: string,
  value: string,
  checked: boolean,
  disabled?: boolean,
  label: string,
  hint: string
};

export default class CheckboxField extends React.PureComponent<Props> {
  render() {
    return (
      <div className="checkbox">
        <label className="twbs-label">
          <span>
            <input
              name={this.props.name}
              type="checkbox"
              value={this.props.value}
              defaultChecked={this.props.checked}
              disabled={this.props.disabled}
            />
            {` ${this.props.label}`}
          </span>
          <small className="text-muted">
            {` (${this.props.hint})`}
          </small>
        </label>
      </div>
    );
  }
}
